import styled, { keyframes } from 'styled-components';
import { DeleteIcon, PlayIcon } from '../const/icons';
import { SECONDARY_COLOR, SECONDARY_COLOR_2, SECONDARY_COLOR_6 } from '../const/color';
import { FAMILY_FONT_CONTROL } from '../const/text';
import { device } from '../const/device';

export const CameraItem = styled.div<{ active: boolean }>`
  width: 8px;
  height: 8px;
  margin-right: 24px;
  border: 1px solid black;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  background-color: ${props => props.active ? 'black' : 'transparent'};

  &:before {
    content: '';
    position: absolute;
    left: -8px;
    top: -8px;
    width: 24px;
    height: 24px;
  }

  &:last-child {
    margin-right: 0;
  }

  @media (${device.tablet}) {
    width: 10px;
    height: 10px;
    margin-right: 28px;

    &:before {
      left: -11px;
      top: -11px;
      width: 32px;
      height: 32px;
    }
  }
`;

export const CameraPlayItem = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${SECONDARY_COLOR} url("data:image/svg+xml,${PlayIcon()}") 10px center / 6px 8px no-repeat;
  cursor: pointer;

  @media (${device.tablet}) {
    width: 30px;
    height: 30px;
    background-position: 12px center;
    background-size: 8px 10px;
  }
`;

export const CameraContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  
  width: 100%;
  height: 30px;
  bottom: 29px;
`;

export const Builder = styled.div`
  //background: #f1f1f8;
  background: rgba(237, 241, 245, 0.75);
  border-radius: 40px;
  height: calc(100vh - 64px);
  
  flex: 3 1 100%;
  overflow: hidden;
  position: relative;
  
  @media (${device.tablet}) {
    flex: 3 1 60vh;
    min-height: 350px;
    border-radius: 26px;
    height:60vh;    
  }

  @media (${device.tabletS}) {
    canvas{
      width:100%;
    }
  }

  @media (${device.mobileL}) {
    border-radius: 0 0 26px 26px;
    margin: -50px -16px 0 -16px;
    max-height: 55vh;
    min-height: 280px;
  }
`;

export const CanvasWrap = styled.div`
  width: 100%;
  height: 100%;
  display:flex;
  align-items:center;
  touch-action: none;
`;


const loaderKeyframes = keyframes`
  from { background-position: 0 0; }
  to { background-position: -1em 0; }
`;

export const Loader = styled.div<{ active: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${SECONDARY_COLOR_6};
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${props => props.active ? 0 : 1};
  transition: opacity 0.3s ease-out;
  pointer-events: none;
  
  &:after {
    content: 'Loading';
    width: 2.5em;
    height: 2.5em;
    border: .05em ${SECONDARY_COLOR_2} solid;
    border-radius: .2em;
    position: relative;
    background: linear-gradient(45deg, transparent 48%, ${SECONDARY_COLOR_2} 50%, ${SECONDARY_COLOR_2} 50%, transparent 52%, transparent), linear-gradient(-45deg, transparent 48%, ${SECONDARY_COLOR_2} 50%, ${SECONDARY_COLOR_2} 50%, transparent 52%, transparent);
    background-size: .5em .5em;
    background-position: 0% 0%;
    animation: ${loaderKeyframes} 1s infinite linear;
    padding-top: 2.5em;
  }
`;

export const MemberRemove = styled.div`
  background: url("data:image/svg+xml,${DeleteIcon()}");
  cursor: pointer;
  width: 16px;
  height: 16px;
`;  

export const MemberRemoveDesktop = styled(MemberRemove)`
  position: absolute;
  right: -14px;
  top: -6px;
  z-index: 2;
`;

export const MemberRemoveMobile = styled(MemberRemove)`
  background-color:${SECONDARY_COLOR_6};
  padding: 12px;
  background-repeat: no-repeat;
  background-position: center;
  border-radius:3px;
`;

export const MemberRender = styled.div<{ image: string }>`
  width:40px;
  height: 44px;
  border: 1px solid transparent;
  background-size: cover;
  border-radius: 40px;
  background: url(${props => props.image}) center / cover no-repeat;
  margin-bottom: 6px;
`;

export const MemberRenderSelectMobile = styled(MemberRender)`
  margin-right:12px;
`;

export const MemberName = styled.div`
  font-size: 12px;
  font-family: ${FAMILY_FONT_CONTROL};
  text-align: center;
  line-height: 14px;
  height: 14px;

  white-space: normal;
  text-overflow: ellipsis;
  width: 60px;
  overflow: hidden;
`;

export const MemberItem = styled.div<{ active: boolean, hasRemove:boolean }>`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  opacity: ${props => props.active ? 1 : 0.6};
  transition: opacity 0.3s cubic-bezier(0.92,-0.02, 0.21, 0.82);
  position: relative;
  width: ${props => props.hasRemove ? "40px" : "60px"};
  margin-bottom: 20px;
  margin-right: ${props => props.hasRemove ? "20px" : "none"};
  align-items: ${props => props.hasRemove ? "start" : "center"};
`;

